// Document Distribution types -- iteration 042

export const DOCUMENT_CATEGORIES = ["newsletter", "schedule", "indemnity", "general"] as const;
export type DocumentCategory = (typeof DOCUMENT_CATEGORIES)[number];

export const ALLOWED_DOCUMENT_MIMES = [
  "application/pdf",
  "image/png",
  "image/jpeg",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
] as const;

export const MAX_DOCUMENT_SIZE_BYTES = 10 * 1024 * 1024; // 10MB

export interface DocumentPublic {
  id: string;
  school_id: string;
  uploaded_by: string;
  uploader_name: string;
  original_name: string;
  mime_type: string;
  size_bytes: number;
  category: DocumentCategory;
  description: string | null;
  is_pinned: boolean;
  pinned_at: string | null;
  created_at: string;
  recipient_count: number;
  _actions: DocumentAction[];
}

export type DocumentAction = "download" | "delete" | "pin" | "view_recipients";

export interface DocumentRecipientPublic {
  id: string;
  user_id: string;
  user_name: string;
  message_id: string | null;
  sent_at: string;
}

export interface DocumentListResponse {
  documents: DocumentPublic[];
}

export interface DocumentDetailResponse {
  document: DocumentPublic;
}

export interface DocumentRecipientListResponse {
  recipients: DocumentRecipientPublic[];
}

/** Minimal document info embedded in message responses */
export interface DocumentAttachment {
  id: string;
  original_name: string;
  mime_type: string;
  size_bytes: number;
}
